"use strict";
import { createAction, createSlice } from "@reduxjs/toolkit";
import { FiatCurrency } from "features/fiatCurrency/constants";
import { Language } from "features/language/constants";
import { getCurrentLanguageFromNavigator } from "features/language/utils";
import { WALLET_TESTNET_CONFIG } from "features/telemetry/constants";
import { isInterface } from "utilities/src/platform";
import { analytics } from "utilities/src/telemetry/analytics/analytics";
export const initialUserSettingsState = {
  currentLanguage: isInterface ? getCurrentLanguageFromNavigator() : Language.English,
  currentCurrency: FiatCurrency.UnitedStatesDollar,
  hideSmallBalances: true,
  hideSpamTokens: true,
  // Default to mainnet mode - only enable testnet when explicitly requested
  isTestnetModeEnabled: process.env.REACT_APP_DEFAULT_TESTNET_MODE === "true"
};
const slice = createSlice({
  name: "userSettings",
  initialState: initialUserSettingsState,
  reducers: {
    setHideSmallBalances: (state, { payload }) => {
      state.hideSmallBalances = payload;
    },
    setHideSpamTokens: (state, { payload }) => {
      state.hideSpamTokens = payload;
    },
    setCurrentLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    setCurrentFiatCurrency: (state, action) => {
      state.currentCurrency = action.payload;
    },
    /**
     * IMPORTANT: minimize and thoroughly vet every usage of this action so that testnets are **never** unintentionally toggled on
     */
    setIsTestnetModeEnabled: (state, { payload }) => {
      state.isTestnetModeEnabled = payload;
      analytics.setTestnetMode(payload, WALLET_TESTNET_CONFIG);
    },
    resetSettings: () => initialUserSettingsState
  }
});
export const {
  setHideSmallBalances,
  setHideSpamTokens,
  setCurrentLanguage,
  setCurrentFiatCurrency,
  setIsTestnetModeEnabled
} = slice.actions;
export const updateLanguage = createAction("language/updateLanguage");
export const syncAppWithDeviceLanguage = () => updateLanguage(null);
export const userSettingsReducer = slice.reducer;
